import type React from "react"
import { useTranslation } from "react-i18next"

import { useFormatCurrency, useFormatDecimal } from "@/formatters"
import { DataGridLegend, DataGridLegendItem } from "@/nzds/data-grid"

import { ComplianceStatus } from "../compliance-status"
import type { ComplianceGridLegendProps } from "./compliance-grid-legend.types"

export const ComplianceGridLegend: React.FC<ComplianceGridLegendProps> = ({
  compliantCount,
  nonCompliantCount,
  siteCount,
  totalPenalties,
}) => {
  const { t } = useTranslation()
  const { formatDecimal: formatDecimalToInteger } = useFormatDecimal({
    precision: 0,
  })

  const { formatCurrency } = useFormatCurrency({
    precision: 0,
  })

  return (
    <DataGridLegend
      itemCount={siteCount}
      itemLabel={t("siteCountLabel", { ns: "sites" })}
    >
      <DataGridLegendItem
        data-testid="non-compliant-count"
        label={<ComplianceStatus isCompliant={false} />}
        value={formatDecimalToInteger(nonCompliantCount)}
      />

      <DataGridLegendItem
        data-testid="compliant-count"
        label={<ComplianceStatus isCompliant={true} />}
        value={formatDecimalToInteger(compliantCount)}
      />

      <DataGridLegendItem
        data-testid="total-fines"
        label={t("potentialFines", { ns: "sites" })}
        value={formatCurrency(totalPenalties)}
      />
    </DataGridLegend>
  )
}
